import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--space-600);
`

export const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const Text = styled.p`
  color: var(--text-secondary);
  font-size: var(--font-size-200);
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-200);
  letter-spacing: var(--font-letter-spacing-looser);
`

export const Line = styled.div<{ color: string }>`
  width: 16px;
  height: 4px;
  border-radius: var(--radius-full);
  background: ${({ color }) => color};
`
